import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'stock-assessment',
    templateUrl: './templates/stock-assessment.component.html',
    styleUrls: ['./styles/stock-assessment.component.css']
})
export class StockAssessmentComponent implements OnInit {

    constructor() {}

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/stock-assessment.component.ts